export default "__VITE_ASSET__BI$iyFN7__"